(() => {
  const productFormSelector = 'form[action*="/cart/add"]';

  const eligibleForms = () => [...document.querySelectorAll(productFormSelector)]
    .filter((form) => form.querySelector('.buy-buttons__atc'));

  const wrapInitialForms = () => {
    if (customElements.get('product-form')) return;
    eligibleForms().forEach((form) => {
      if (form.closest('product-form')) return;
      const wrapper = document.createElement('product-form');
      wrapper.className = 'product-form block';
      wrapper.dataset.hideErrors = 'false';
      form.parentNode.insertBefore(wrapper, form);
      wrapper.appendChild(form);
    });
  };

  const installProductUx = () => {
    const template = document.getElementById('MhProductUxFallback');
    const information = document.querySelector('.product-detail__information');
    if (!template || !information) return;

    const content = template.content.cloneNode(true);
    if (!information.querySelector('.mh-product-proof')) {
      const proof = content.querySelector('.mh-product-proof');
      const price = information.querySelector('.product-detail__price');
      if (proof && price) price.insertAdjacentElement('afterend', proof);
    }

    if (!information.querySelector('mh-delivery-estimate')) {
      const delivery = content.querySelector('mh-delivery-estimate');
      const form = eligibleForms().find((candidate) => information.contains(candidate));
      const anchor = form?.closest('product-form') || form;
      if (delivery && anchor) anchor.insertAdjacentElement('afterend', delivery);
    }
  };

  const showFormMessage = (form, message) => {
    let status = form.parentElement.querySelector('.mh-cart-rescue__message');
    if (!status) {
      status = document.createElement('p');
      status.className = 'mh-cart-rescue__message';
      status.setAttribute('role', 'alert');
      form.insertAdjacentElement('afterend', status);
    }
    status.textContent = message;
  };

  const updateCartCount = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cartState = await response.json();
    document.querySelectorAll('.cart-count').forEach((element) => {
      if (element.classList.contains('cart-count-drawer')) {
        element.textContent = `(${cartState.item_count})`;
      } else {
        element.textContent = cartState.item_count > 100 ? '~' : cartState.item_count;
      }
    });
  };

  const submitWithoutWrapper = async (form) => {
    if (form.dataset.mhRescueSubmitting === 'true') return;
    form.dataset.mhRescueSubmitting = 'true';
    const button = form.querySelector('.buy-buttons__atc');
    button?.setAttribute('aria-disabled', 'true');
    button?.classList.add('loading');

    try {
      const formData = new FormData(form);
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      const baseUrl = window.routes?.cart_add_url || '/cart/add';
      const addUrl = baseUrl.endsWith('.js') ? baseUrl : `${baseUrl}.js`;
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'This item could not be added.');

      await updateCartCount();
      if (cart && state.sections && typeof cart.getSectionsToRender === 'function') {
        cart.getSectionsToRender().forEach((section) => {
          const target = document.getElementById(section.id);
          const html = new DOMParser().parseFromString(state.sections[section.id] || '', 'text/html');
          const source = html.querySelector('#minicart-form');
          if (target && source) target.innerHTML = source.innerHTML;
        });
      }

      document.dispatchEvent(new CustomEvent('mh:cart-added', { detail: state }));
      if (cart && typeof cart.cartAction === 'function') cart.cartAction();
      if (cart && typeof cart.open === 'function') {
        cart.open();
      } else {
        window.location.assign(window.routes?.cart_url || '/cart');
      }
    } catch (error) {
      showFormMessage(form, error.message || 'Please try adding this item again.');
    } finally {
      delete form.dataset.mhRescueSubmitting;
      button?.removeAttribute('aria-disabled');
      button?.classList.remove('loading');
    }
  };

  const boot = () => {
    wrapInitialForms();
    installProductUx();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.(productFormSelector);
    const submitter = event.submitter || document.activeElement;
    if (!form || !form.querySelector('.buy-buttons__atc') || !submitter?.matches?.('.buy-buttons__atc')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitWithoutWrapper(form);
  }, true);
})();
